import InputControl from '../InputControl/InputControl.vue.js';
import ButtonControl from '../ButtonControl/ButtonControl.vue.js';

//
var script = {
  name: 'Coupon',
  components: {
    InputControl: InputControl,
    ButtonControl: ButtonControl
  },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input'
  },
  inject: {
    formItem: {
      default: ''
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Промокод'
    },
    isSuccessful: {
      type: Boolean,
      default: false
    },
    successfulText: {
      type: String,
      default: 'Промокод применён'
    },
    isError: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: 'Промокод не найден'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: 'Применить'
    }
  },
  computed: {
    query: {
      get: function get() {
        return this.value;
      },

      set: function set(value) {
        this.$emit('input', value);
      }

    },

    isSuccessfulDI: function isSuccessfulDI() {
      return this.formItem ? this.formItem.isValid : this.isSuccessful;
    },

    successfulTextInput: function successfulTextInput() {
      return this.isSuccessful ? this.successfulText : '';
    },

    errorTextInput: function errorTextInput() {
      return this.isError ? this.errorText : '';
    }

  },
  methods: {
    handlerRemove: function handlerRemove() {
      this.$emit('remove');
    },

    handlerApply: function handlerApply() {
      this.$emit('apply');
    },

    handlerFocus: function handlerFocus() {
      this.$emit('focus');
    },

    handlerBlur: function handlerBlur() {
      this.$emit('blur');
    },

    onFocus: function onFocus() {
      this.$refs.input.focus();
    },

    onBlur: function onBlur() {
      this.$refs.input.blur();
    }

  }
};

export default script;
